import {
  HeaderService,
  PresentationListService,
  StaticPageService,
  UpdateNoteService,
} from "./components";

export type PresentationNotesPageAgent = {
  getHeaderProps(): Promise<any>;
  getPresentationListProps(args: any): Promise<any>;
  getStaticPageContentSync(args: any): any;
  updateNote(args: { id: string; note: string }): Promise<any>;
};

export const getAgent = (): PresentationNotesPageAgent => {
  const headerService = new HeaderService();
  const presentationListService = new PresentationListService();
  const staticPageService = new StaticPageService();
  const updateNoteService = new UpdateNoteService();

  return {
    getHeaderProps: headerService.getHeaderProps.bind(headerService),
    getPresentationListProps:
      presentationListService.getPresentationListProps.bind(presentationListService),
    getStaticPageContentSync:
      staticPageService.getStaticPageContentSync.bind(staticPageService),
    updateNote: updateNoteService.updateNote.bind(updateNoteService),
  };
};
